import type { FC } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Typography } from '@material-ui/core';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Link from '@material-ui/core/Link/Link';

interface BreadCrumb {
  label: string;
  url: string;
}

interface BreadCrumbsProps {
  breadCrumbs: BreadCrumb[];
}

export const BreadCrumbView: FC<BreadCrumbsProps> = (props) => {
  const { breadCrumbs } = props;
  const breadCrumbsValues = [
    <Link
      underline="none"
      color="primary"
      href="/"
      variant="body2"
      key="Home"
    >
      Home
    </Link>
  ];
  breadCrumbs.forEach((element, index) => {
    if (index === breadCrumbs.length - 1) {
      breadCrumbsValues.push(
        <Typography
          color="text.primary"
          variant="body2"
          key={element.label}
        >
          {element.label}
        </Typography>
      );
    } else {
      breadCrumbsValues.push(
        <Link
          underline="none"
          color="primary"
          href={element.url}
          variant="body2"
          key={element.label}
        >
          {element.label}
        </Link>
      );
    }
  });
  return (
    <Breadcrumbs
      separator={<ChevronRightRoundedIcon fontSize="small" />}
    >
      {breadCrumbsValues}
    </Breadcrumbs>
  );
};
BreadCrumbView.propTypes = {
  breadCrumbs: PropTypes.array.isRequired
};
